import React,{useState} from 'react'

import './Contact.css'
import Footer from '../../components/Footer/Footer';

import axios from 'axios';

const Contact = () => {
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [sent, setSent] = useState(false);

    // handle input
    const handleName=(e)=> {
        setName(
            e.target.value
        )
    }

    const handleLastName=(e)=> {
        setLastName(
            e.target.value
        )
    }


   const handleEmail=(e)=> {
        setEmail(
            e.target.value
        )
    }

   const handleMessage=(e)=> {
        setMessage(
            e.target.value
        )
    }

  /*  handleSent=(e)=> {
        setSent({
            sent:e.target.value
        })
    }

*/

const formSubmit=(e)=>{
    e.preventDefault();
    let data = {
        name:name,
        lastName:lastName,
        email:email,
        message:message
    }
    axios.post('/api/forma',data)
    .then(res=> {
        setSent({
            sent:true,
        },resetForm())
    })
    .catch(()=>{
        console.log("message not sent");
    })
}

// for reseting initial data
const resetForm=()=>{
    setName(
        ''
    )
    setLastName(
        ''
    )
    setEmail(
        ''
    )
    setMessage(
        ''
    )
    setTimeout(()=>{
        setSent(
            false,
        )
    },3000)
}

  return (
      <>
      <div className='htmlClass'>



<section className="contact">

<div className="icons-container">

    <div className="icons">
        <i className="fas fa-phone"></i>
        <h3>our number</h3>
        <p>+33 6 01 55 13 49</p>
    </div>

    <div className="icons">
        <i className="fas fa-envelope"></i>
        <h3>our email</h3>
        <p>contact@agil4you.com</p>
        <p>support@agil4you.com</p>
    </div>

    <div className="icons">
        <i className="fas fa-map-marker-alt"></i>
        <h3>our address</h3>
        <p> Île-de-France , Paris</p>
    </div>

</div>
 {/*   
<div class="row">

    <form onSubmit={formSubmit}>
        <h3>get in touch</h3>
        <input type="text"
         placeholder="your name"
         class="box"
         name="name"
         value={name}
         onChange={handleName}

          />
        
        
        <input type="number"
         placeholder="your number"
         class="box"
         name="lastName"
         value={lastName}
         onChange={handleLastName}

          />
        
        <input type="email"
         placeholder="your email"
         class="box"
         name="email"
         value={email}
         onChange={handleEmail}
         required

          />
        <textarea name="message"
          placeholder="your message"
          id=""
          cols="30"
          rows="10"
          value={message}
          onChange={handleMessage}

           ></textarea>  
           <div className={sent ? 'msg msgAppear':'msg'}>Message has been sent</div>

        <button type="submit"  class="btn">Send</button>
    </form>

    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.76457506271!2d2.2769953230035505!3d48.85894658093097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b70f%3A0x40b82c3688c9460!2sParis%2C%20France!5e0!3m2!1sen!2sin!4v1640272298798!5m2!1sen!2sin" width="600" height="450"  allowFullscreen="" loading="lazy"></iframe>
</div>
*/} 
</section>
    
   
   
    </div>
    <Footer/>
    </>
  )
}

export default Contact
